import { Link } from 'react-router-dom'
import InteractiveSimpleCategoryCard from './InteractiveSimpleCategoryCard'
import ShowMoreCard from './ShowMoreCard'

interface CategoryBlockProps {
  title: string
  categoryId: number
  items: any[]
  itemType: 'subcategories' | 'cards'
  className?: string
  isAvailableContent?: boolean
  maxItems?: number
  onCategoryClick?: (categoryId: number) => void
  onSeeAllClick?: (categoryId: number) => void
  onToggleFavorite?: (itemId: string) => void
  favorites?: string[]
  hasSubscription?: boolean
  searchQuery?: string
  onScrollToTop?: () => void
  lockContent?: boolean
  seeAllLink?: string
}

const CategoryBlock = ({
  title,
  categoryId,
  items,
  itemType,
  className = 'category-block',
  isAvailableContent = false,
  maxItems,
  onCategoryClick,
  onSeeAllClick,
  onToggleFavorite,
  favorites = [],
  hasSubscription,
  searchQuery = '',
  onScrollToTop,
  lockContent = false,
  seeAllLink,
}: CategoryBlockProps) => {
  // Сколько плиток влезает в превью категории.
  const previewLimit = maxItems ?? (isAvailableContent ? undefined : 6)
  const gridClass = isAvailableContent
    ? 'available-content-grid'
    : 'categories-grid'

  return (
    <div className={className}>
      <div className="category-block-header">
        <h3>{title}</h3>
        {/* «Все» оставляем только там, где ведёт на отдельную страницу.
            В превью категорий её заменила плитка «Ещё» в конце списка: она
            стоит там, где список обрывается, и показывает, сколько скрыто. */}
        {seeAllLink && (
          <Link to={seeAllLink} className="see-all-link">
            Все
          </Link>
        )}
      </div>

      <div className={gridClass}>
        {items.slice(0, previewLimit).map(item => {
          const itemId = (
            itemType === 'subcategories' ? item.category_id : item.card_id
          ).toString()

          return (
            <InteractiveSimpleCategoryCard
              key={itemId}
              item={item}
              showingType={itemType}
              onCategoryClick={onCategoryClick}
              onToggleFavorite={
                itemType === 'cards' ? onToggleFavorite : undefined
              }
              isFavorite={
                itemType === 'cards' ? favorites.includes(itemId) : false
              }
              hasSubscription={hasSubscription}
              searchQuery={searchQuery}
              onScrollToTop={onScrollToTop}
              lockContent={lockContent}
            />
          )
        })}

        {/* Показываем там же, где раньше стояла «Все» в шапке. */}
        {!isAvailableContent && !seeAllLink && (
          <ShowMoreCard
            onClick={() => {
              onScrollToTop?.()
              onSeeAllClick?.(categoryId)
            }}
          />
        )}
      </div>

      {items.length === 0 && (
        <div className="empty-state">
          <p>
            {itemType === 'subcategories'
              ? 'Подкатегории не найдены'
              : 'Карточки не найдены'}
          </p>
        </div>
      )}
    </div>
  )
}

export default CategoryBlock
